module.exports = __webpack_public_path__ + "res/32-img_game_bg.6b76083181a2c436631a5de5fa0fd75b.png";